const EmailType = Symbol();

// メールアドレスの最大長
export const UserEmailMaxLength = 100;
// メールアドレスの@より前部分の最大長
export const UserEmailNameMaxLength = 64;
// メールアドレスの@より後部分の最大長
export const UserEmailDomainMaxLength = 256;

export class UserEmail {
    [EmailType]: any;
    readonly value: string;

    private constructor(email: string) {
        this.value = email;
    }

    // メールアドレスのフォーマットチェック
    isValid(): boolean {
        return /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(this.value);
    }

    // メールアドレスの最大長チェック
    isValidLength(): boolean {
        return !(this.value.length > UserEmailMaxLength);
    }

    // メールアドレスの@より前部分の最大長チェック
    isValidEmailNameLength(): boolean {
        return !(this.value.split("@")[0].length > UserEmailNameMaxLength);
    }

    // メールアドレスの@より後部分の最大長チェック
    isValidEmailDomainLength(): boolean {
        return !(this.value.split("@")[1].length > UserEmailDomainMaxLength);
    }

    static fromString(email: string): UserEmail {
        return new UserEmail(email);
    }

    static fromNothing(): UserEmail {
        return new UserEmail("");
    }
}
